import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { thClass, tdClass, STATUS_LABELS } from './adminUi';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Transitions admin autorisées (miroir du back-end returns).
const TRANSITIONS = {
  requested: ['approved', 'rejected'],
  approved: ['received', 'refunded', 'rejected'],
  received: ['refunded', 'rejected'],
  refunded: [],
  rejected: [],
};

const AdminReturns = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () =>
    axios
      .get(`${API}/admin/returns`)
      .then((r) => setItems(Array.isArray(r.data) ? r.data : r.data.returns || []))
      .catch(() => toast.error('Échec du chargement des retours'))
      .finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, []);

  const setStatus = async (ret, status) => {
    try {
      await axios.put(`${API}/admin/returns/${ret.id}/status`, { status });
      toast.success(`Retour ${STATUS_LABELS[status] || status}`);
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    }
  };

  return (
    <div data-testid="admin-returns">
      <h2 className="font-heading text-2xl mb-6">Retours</h2>
      {loading ? (
        <p className="text-foreground/40">Chargement…</p>
      ) : items.length === 0 ? (
        <p className="text-foreground/40 py-8">Aucune demande de retour.</p>
      ) : (
        <div className="overflow-x-auto border border-black/10">
          <table className="w-full">
            <thead>
              <tr>
                <th className={thClass}>Retour</th>
                <th className={thClass}>Commande</th>
                <th className={thClass}>Motif</th>
                <th className={thClass}>Statut</th>
                <th className={thClass}>Action</th>
              </tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.id}>
                  <td className={`${tdClass} font-mono text-xs`}>{(r.id || '').slice(0, 8)}</td>
                  <td className={`${tdClass} font-mono text-xs`}>{(r.order_id || '').slice(0, 8)}</td>
                  <td className={tdClass}>{r.reason || '—'}</td>
                  <td className={tdClass}>
                    <span className="text-gold">{STATUS_LABELS[r.status] || r.status}</span>
                  </td>
                  <td className={tdClass}>
                    {(TRANSITIONS[r.status] || []).length === 0 ? (
                      <span className="text-foreground/30 text-xs">Terminé</span>
                    ) : (
                      <select
                        className="bg-transparent border border-black/15 text-foreground text-sm px-2 py-1.5 focus:border-gold focus:outline-none"
                        value=""
                        onChange={(e) => e.target.value && setStatus(r, e.target.value)}
                        data-testid="return-status"
                      >
                        <option value="" className="bg-background">Changer…</option>
                        {TRANSITIONS[r.status].map((s) => (
                          <option key={s} value={s} className="bg-background">{STATUS_LABELS[s] || s}</option>
                        ))}
                      </select>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminReturns;
